import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateFieldResourceUpdateHighlight } from 'apps/web_forms/slices/formSlice';

/**
 * @typedef {Object} UseResourceUpdateHighlight
 * @property {boolean} hasResourceUpdateHighlight
 * @property {() => void} removeResourceUpdateHighlight
 */

/**
 *
 * @param {Object} props
 * @param {string} props.fieldIdentifier
 * @returns {UseResourceUpdateHighlight}
 */
const useResourceUpdateHighlight = ({ fieldIdentifier }) => {
  const dispatch = useDispatch();

  const hasResourceUpdateHighlight = useSelector(
    (state) => state.form.fieldResourceUpdateHighlights[fieldIdentifier]
  );

  const removeResourceUpdateHighlight = useCallback(() => {
    if (hasResourceUpdateHighlight) {
      dispatch(
        updateFieldResourceUpdateHighlight({
          fieldIdentifier,
          isHighlighted: false,
        })
      );
    }
  }, [dispatch, fieldIdentifier, hasResourceUpdateHighlight]);

  return {
    hasResourceUpdateHighlight,
    removeResourceUpdateHighlight,
  };
};

export default useResourceUpdateHighlight;
